<template>
    <div class="v_pagination" v-if="page.total>9">

    <el-pagination
    background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="[10,20,50]"
        :current-page="page.page"
        :page-size="page.num"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
     
    >
    <!-- :hide-on-single-page="true" -->
    </el-pagination>
</div>

</template>
<script>
export default {
    props:{
        page:{
                type:Object,
                default:"",
                required:false
            }
    },
    methods: {
        handleCurrentChange(val) {
            this.$emit('getPage',val)
        },
        handleSizeChange(val) {
        this.$emit('getNum',val)
       
      },
    },
    data() {
        return {
            pages:1
        };
    }
};
</script>
<style lang="scss" scoped>
/deep/.el-pager, .el-pager li {
    display: flex;
    align-items: center;
}
/deep/.el-pager .number{
    background: none !important;
    width: 42px;
    height: 40px;
    line-height: 40px;
}
/deep/.el-pagination{
    display: flex;
    align-items: center;
}
/deep/.el-pager .active{
    background-color: #91D9F2 !important;

}
/deep/.el-pagination.is-background .btn-next {
    background: none !important;

}
/deep/.el-pagination.is-background .btn-prev{
    background: none !important;

}
</style>
